import { z } from 'zod';

export const SUMMARY_MAX_CHARS = 12_000;
export const threadSummaryBookmarkSchema = z
  .object({
    kind: z.enum(['decision', 'constraint', 'topic', 'open_question']),
    text: z.string().min(1).max(400),
    messageIds: z.array(z.string().uuid()).min(1).max(6),
  })
  .strict();
export const threadSummaryBookmarksSchema = z
  .array(threadSummaryBookmarkSchema)
  .max(24);
export type ThreadSummaryBookmark = z.infer<typeof threadSummaryBookmarkSchema>;

/** Internal checkpoint for a bounded fold; not yet published model history. */
export const threadSummaryProgressSchema = z
  .object({
    v: z.literal(1),
    revision: z.string().uuid(),
    until: z.string().datetime(),
    sourceHash: z.string().regex(/^[\da-f]{64}$/),
    offset: z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER),
    bookmarks: threadSummaryBookmarksSchema.optional(),
    targetUntil: z.string().datetime().optional(),
    summary: z.string().min(1).max(SUMMARY_MAX_CHARS),
  })
  .strict();

export type ThreadSummaryProgress = z.infer<typeof threadSummaryProgressSchema>;
